<template>
  <div class="pad-bottom wh-item">
    <RouterLink :to="routeTo">
      <div class="data-item__img" :style="`background-image:url(${mediaUrl})`" />
      <div v-if="item.title" class="category-head__title wh-item__title">{{ item.title }}</div>

      <div class="wh-item__subcontent">
        <DataItemDates :dates="dates" />

        <div v-if="item.destination && item.destination.title" class="d-flex">
          <div v-if="item.destination.title" class="small-grey">{{ item.destination.title }},</div>
          <div v-if="item.destination.country" class="small-grey ml-1">{{ item.destination.country }}</div>
        </div>

        <div v-if="item.artSpace && item.artSpace.title" class="small-grey">{{ item.artSpace.title }}</div>
      </div>
    </RouterLink>
  </div>
</template>

<script>
import { getEntityRoute } from '@/helpers/entityType';
import ImageHandler from '@/helpers/ImageHandler';
import DataItemDates from '@/components/partials/DataItemDates';

export default {
  name: 'DestinationWhatsHappeningItem',
  components: { DataItemDates },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dates() {
      if (this.item.date && this.item.date.length) {
        return this.item.date;
      }

      return [
        {
          start_date: this.item.start_date || this.item.earliest_start_date || null,
          end_date: this.item.end_date || this.item.latest_end_date || null,
        },
      ];
    },
    mediaUrl() {
      return new ImageHandler().getFirstImgFromMedia(this.item);
    },
    routeTo() {
      return getEntityRoute(this.item);
    },
  },
};
</script>

<style lang="scss">
@use '@/assets/scss/variables-site/variables' as vars;

.wh-item {
  padding-bottom: 20px;

  @media (min-width: vars.$tablet-break-point) {
    padding-bottom: 50px;
  }

  .data-item__img {
    transition: all 0.2s linear;
  }

  a:hover {
    .data-item__img {
      transform: scale(0.95);
    }
  }

  &__title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 1px;

    @media (min-width: vars.$tablet-break-point) {
      font-size: 22px;
      line-height: 30px;
    }
  }

  &__subcontent {
    .small-grey {
      font-size: 14px;
      line-height: 20px;

      @media (min-width: vars.$tablet-break-point) {
        font-size: 18px;
        line-height: 25px;
      }
    }
  }
}
</style>
